import { IInfluencer, IPlatformStats } from '../../redux/buzzbridge/types';
import { FormData, PlatformData } from './InfluencerSignupForm';

export function mapFormDataToInfluencerPayload(formData: FormData): Partial<IInfluencer> {
    const influencer: Partial<IInfluencer> = {
        name: formData.name,
        categories: formData.categories.map(cat => ({
            main: cat,
        })),
    };

    // Map platform names to IInfluencer property keys
    const platformKeyMap: Record<
        string,
        keyof Pick<IInfluencer, 'instagram' | 'tiktok' | 'youtube' | 'facebook' | 'twitter' | 'thspian'>
    > = {
        Instagram: 'instagram',
        YouTube: 'youtube',
        TikTok: 'tiktok',
        Facebook: 'facebook',
        Twitter: 'twitter',
        Thspian: 'thspian',
    };

    const platformKeys = Object.keys(formData.platforms) as (keyof typeof formData.platforms)[];

    platformKeys.forEach(platformKey => {
        const platformData: PlatformData = formData.platforms[platformKey];
        if (!platformData.isActive) return;

        const influencerPlatformKey = platformKeyMap[platformKey];
        if (!influencerPlatformKey) return;

        if (platformData.entryType === 'manual') {
            const platformStats: IPlatformStats = {
                username: platformData.manualData.userName,
                followers: Number(platformData.manualData.followers) || 0,
                engagementRate: Number(platformData.manualData.engagementRate) * 0.01 || 0,
                avg_likes: Number(platformData.manualData.totalLikes) || 0,
                avg_comments: Number(platformData.manualData.averageComments) || 0,
                verified: false, // Assuming manual entries are not verified
                pricing: Object.fromEntries(
                    Object.entries(platformData.rateCard).map(([contentType, range]: [any, any]) => [
                        contentType.toLowerCase(),
                        range, // Use the full range [min, max]
                    ]),
                ),
            };
            influencer[influencerPlatformKey] = platformStats;
        } else if (platformData.entryType === 'automatic' && platformData.isLinked) {
            const platformStats: IPlatformStats = {
                username: platformData.linkedContent.username, // Placeholder – fill from API if needed
                verified: true,
                pricing: Object.fromEntries(
                    Object.entries(platformData.rateCard).map(([contentType, range]: [any, any]) => [
                        contentType.toLowerCase(),
                        range, // Use the full range [min, max]
                    ]),
                ),
                audience_demographics: platformData.linkedContent.audience_demographics,
                avg_comments: platformData.linkedContent.avg_comments,
                avg_likes: platformData.linkedContent.avg_likes,
                engagementRate: platformData.linkedContent.engagementRate,
                followers: platformData.linkedContent.followers,
                profile_link: platformData.linkedContent.profile_link,
                profile_picture: platformData.linkedContent.profile_picture,
                // ...platformData.linkedContent,
            };
            influencer[influencerPlatformKey] = platformStats;
        }
    });

    return influencer;
}
